<script lang="ts">

    import InfoPill from './InfoPill.svelte';
    import {assets as assetPath} from '$app/paths'
    import type { Benefits, PriceCurrency } from 'src/types';

    export let tierType : string
    export let cardDescription : string
    export let price : string
    export let tierBenefits : Benefits[]
    export let tierIcon : string
    export let currency : PriceCurrency = '€'
    export let priceDescription : string = 'per month'
    export let showCurrency: boolean = true
    export let showUnlimitedHires: boolean = true
    export let showRecommended: boolean = false
    export let pricingOption: string = 'unlimited-subscriptions'


</script>

<div class="pricing-card">
    {#if showRecommended}
        <div class="pricing-card__recommended">
            <img src="https://assets-global.website-files.com/5e8b2955eaa7857dbbd850ad/6537c31f50b49be9e7fd9f7b_Icon.svg" alt="star icon" loading="lazy"/>Recommended
        </div>
    {/if}
     <div class="pricing-card__top">
        <!-- <img src={tierIcon} alt="tier icon" class="tier-icon"/> -->
        <h3 class="pricing-tier">{tierType}</h3>
        <p class="card-description">{@html cardDescription}</p>
        <p class="price">
            {#if showCurrency}
                <span class="price-description" style:color={showCurrency ? 'transparent' : 'inherit'}>Starting from:</span>
                {currency}
            {/if}{price}
            {#if tierType !== 'Enterprise'}<span class="duration">{priceDescription}</span> {/if}
        </p>
     </div>
     <div class="pricing-card__bottom">
        <p class="benefits-card-includes">Includes:</p>
        {#if showUnlimitedHires}<p class="top-feature-hightlight"><img src="{assetPath}/assets/pricing/infinity-icon.svg" alt="infinity-logo">Unlimited hires</p>{/if}
        <ul class="benefits-list">
            { #each tierBenefits as benefit }
                <li><span class="benefits-list__text" style:font-weight={benefit.highlight ? '700' : '400'} style:color={benefit.highlight ? '#fff' : ''}>{benefit.description} { #if !benefit.active } <InfoPill className="coming-soon-pill" theme="green"/> { /if } </span></li>
            { /each }
        </ul>
     </div>
</div>

<style lang="postcss">

    @import '../../styles/_mixins.css';

    .pricing-card {

        border:solid, 1px;
        border-color:rgba(#2f96f4, .3);
        border-radius: 15px;
        max-width:550px;
        width:100%;
        background-color: #031648;
        min-height:100%;
        box-shadow: 2px 2px 2px rgba(#0b1236, .25);
        position: relative;

        @mixin screen-lg {
            max-width:480px;
            min-height:820px;
        }

        @mixin screen-sm {
            max-width:100%;
            min-height:100%;
        }

        & .pricing-card__top {
            background-color: #00072F;
            padding:24px;
            border-radius: 15px 15px 0 0;

            & .tier-icon {
                width:50px;
            }
            & .pricing-tier {
                font-size:42px;
                font-weight:700;
                color:#fff;
                margin:16px 0;
            }

            & .card-description {
                font-size:18px;
                color:#dae0e4;
                margin:0 0 16px;
                line-height:130%;
                /* white-space: nowrap; */
                min-height:50px;

                & :global(span) {
                    font-weight:700;
                    color:#5ea5ee;
                }

                @mixin screen-lg {
                    white-space: wrap;
                    font-size:18px;
                }
            }

            & .price {
                font-size:45px;
                font-weight: 800;
                color:#fff;
                margin:0 0 16px;

                & .price-description{
                    font-size:16px;
                    color:#dae0e4;
                    font-weight:400;
                    display: block;
                    margin:0 0 16px;

                    @mixin screen-lg {
                        margin:0 0 18px;
                    }
                }

                & .duration {
                    font-size:16px;
                    color:#dae0e4;
                    font-weight:400;
                    margin:0;
                }
            }

            & :global(.pricing-cta) {
                width:100%;
                margin:0 0 16px;
                max-width: 100%;
            }

            & .payment-information {
                font-size:16px;
                color:#e4f0fc;
                display: flex;
                gap:8px;
                align-items: center;
                margin:0;
            }
        }

        & .pricing-card__bottom {
            background-color: #031648;
            padding:24px;
            border-radius: 0px 0px 15px 15px;

            & .benefits-card-includes {
                font-size:18px;
                font-weight: 600;
                color: rgba(#e4f0fc, .5);
                margin:0 0 16px;
            }

            & .top-feature-hightlight {
                font-weight:700;
                font-size:18px;
                color:#fff;

                & img {
                    margin:0 7px 0;
                }
            }

            & .benefits-list {
                margin:0;
                padding:0 0 0 27px;
                color:#5ea5ee;
                display: flex;
                flex-direction: column;
                gap:16px;

                & li {
                    & .benefits-list__text {
                        font-size:18px;
                        color:#e4f0fc;
                        margin:0 16px 0 9px;

                        @mixin screen-lg {
                            display:flex;
                            flex-direction:column;
                            gap:8px 0;
                        }
                    }

                    & :global(.coming-soon-pill) {
                        margin-left:16px;
                        @mixin screen-lg {
                            margin:0;
                            align-self:flex-start;
                        }
                    }
                }
            }

        }

        & .pricing-card__recommended {
            font-size:20px;
            padding:10px 16px;
            font-weight:600;
            border-radius: 8px;
            border-color:rgba(#2f96f4, .2);
            background-color: #ba69c8;
            color:var(--color_white);
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-0%, -0%);
            left:35%;
            top:-20px;
            display: flex;
            gap:8px;
            align-items: center;

            @mixin screen-md {
                left:30%;
            }

            @mixin screen-sm {
                left:22%;
            }
        }
    }

</style>